export default __webpack_public_path__ + "static/media/oneclick.304b3ca8.webp";